import type { Organization } from '../types/organization'
import type { OrganizationLogoDownloadAction, OrganizationLogoKey } from '../types'

export function coerceCharity(value: Organization['charity'] | undefined): '0' | '1' | '' {
  if (value === '1' || value === 1) return '1'
  if (value === '0' || value === 0) return '0'
  return ''
}

export function normalizeHexColorForInput(v: string | undefined): string {
  if (!v?.trim()) return '#ffffff'
  const t = v.trim()
  if (/^#[0-9A-Fa-f]{6}$/i.test(t)) return t
  if (/^[0-9A-Fa-f]{6}$/i.test(t)) return `#${t}`
  return '#ffffff'
}

export function fileLabelFromServerPath(s: string | undefined): string {
  if (!s?.trim()) return ''
  const path = s.split('?')[0]
  const parts = path.split(/[/\\]/).filter(Boolean)
  return parts[parts.length - 1] ?? s
}

export function emailFooterLooksLikeHtml(v: string): boolean {
  const t = v.trim()
  if (!t) return false
  if (/<!DOCTYPE/i.test(t) || /<\s*html[\s>]/i.test(t)) return true
  return /<[a-z][\s\S]*?>/i.test(t)
}

export function buildOrganizationLogoDownloadAction(
  key: OrganizationLogoKey,
  opts: {
    orgId: number | undefined
    isEdit: boolean
    logoFiles: Partial<Record<OrganizationLogoKey, File>>
    logoBlobPreviewUrls: Partial<Record<OrganizationLogoKey, string>>
    logoServerSrc: Record<OrganizationLogoKey, string>
  },
): OrganizationLogoDownloadAction | undefined {
  const file = opts.logoFiles[key]
  const blobUrl = opts.logoBlobPreviewUrls[key]
  const serverPath = opts.logoServerSrc[key]?.trim()

  if (file && blobUrl) {
    return { kind: 'local', file, objectUrl: blobUrl }
  }
  if (opts.isEdit && opts.orgId != null && serverPath && !file) {
    return { kind: 'server', orgId: opts.orgId, filePath: serverPath }
  }
  return undefined
}
